import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import config from "../config";
import Plusicon from "../assets/icons/plus_icon";
import Customericon from "../assets/icons/customer_icon";
import Settingicon from "../assets/icons/setting_icon";
import Profileimage from "../assets/icons/profile.jpg";
import PencilIcon from "../assets/icons/pencil_icon";
import axios from "axios";
import { X } from 'lucide-react';



const Sidebar = ({isSidebarOpen,toggleSidebar}) => {
  const location = useLocation();
   const [settings, setSettings] = useState({ title: '', logo: '' });
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);
  
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/api/setting/`);
        if (response.data && response.data.data) {
          setSettings(response.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch settings:", err);
        setError("Could not load settings.");
      }
    };
    fetchSettings();
  }, []); 

  
  const handleEditIconClick = () => {
    // This triggers the hidden file input
    fileInputRef.current.click();
  };

  // --- 3. Function to handle the file upload ---
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      return; // Do nothing if no file is selected
    }

    const formData = new FormData();
    formData.append('logo', file);

    try {
    
      const response = await axios.put(`${config.BASE_URL}/api/setting/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data && response.data.data) {
        setSettings(response.data.data);
        console.log("Logo updated successfully!");
      }
    } catch (err) {
      console.error("Failed to upload logo:", err);
      setError("Logo upload failed. Please try again.");
    }
  };


  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes("orders")) return "orders";
    if (path.includes("quotes")) return "quotes";
    if (path.includes("customers")) return "customers";
    if (path.includes("settings")) return "settings";
    return "customers";
  };

  const activeTab = getActiveTab();


   const logoSrc = settings.logo
    ? `${config.BASE_URL}${settings.logo}`
    : Profileimage;

  return (
    <div className="sidebar">
  {isSidebarOpen &&  <div className="sidebar-cross" onClick={toggleSidebar}>
            <X size={20}/>
          </div>}
    
      <div className="logo">
        <Link to="/" className="home-link"> <img src={`${config.FRONT_URL}/bentex-sidebar-logo.jpg`} /> </Link>
      </div>
      <div className="sidebar_user">
        <div className="profile_image">
          <img src={logoSrc} alt="Profile" className="profile_image" />
           <button type="button" className="edit_profile" onClick={handleEditIconClick}>
            <PencilIcon />
          </button>

          
        </div>
        
        {/* --- 4. Hidden file input that we trigger programmatically --- */}
        <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }} // This element is invisible to the user
            accept="image/png, image/jpeg, image/gif, image/webp"
        />
        <div className="profile_customer_details">
          <h6>Bentex</h6>
          <p>Suits & Shirts</p>
        </div>
      </div>
      <nav className="menu">
        <Link
          to="/orders"
          className={activeTab === "orders" ? "active" : ""}
        >
          <Plusicon />
          Orders
        </Link>
        <Link
          to="/quotes"
          className={activeTab === "quotes" ? "active" : ""}
        >
          <Plusicon />
          Quotes
        </Link>
        <Link
          to="/customers"
          className={activeTab === "customers" ? "active" : ""}
        >
          <Customericon />
          Customers
        </Link>
        <Link
          to="/settings"
          className={activeTab === "settings" ? "active" : ""}
        >
          <Settingicon />
          Settings
        </Link>
      </nav>
    </div>
  );
};

export default Sidebar;

